import { HttpClient } from '@angular/common/http';
import { oneAssetApi } from '../constants/constants';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var PerformanceCalculationService = /** @class */ (function () {
    function PerformanceCalculationService(http) {
        this.http = http;
        this._performanceCalUrl = oneAssetApi + "/Performance/Summary";
    }
    PerformanceCalculationService.prototype.getPerformanceSum = function (fundId, date) {
        var _body = { fundId: fundId, date: date };
        return this.http.post(this._performanceCalUrl, _body);
    };
    PerformanceCalculationService.ngInjectableDef = i0.defineInjectable({ factory: function PerformanceCalculationService_Factory() { return new PerformanceCalculationService(i0.inject(i1.HttpClient)); }, token: PerformanceCalculationService, providedIn: "root" });
    return PerformanceCalculationService;
}());
export { PerformanceCalculationService };
